import {
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_BEGIN,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_SUCCESS,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_FAILURE,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
export function createCollectionWithAirtable(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_BEGIN,
    });
    const { version, projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/airtable/create-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_SUCCESS,
            data: res,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response) || ` to create Collection`;
          console.log('err222', err);
          toast.error(`Failed: ${errMsg}`);
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithAirtableError() {
  return {
    type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_BEGIN:
      return {
        ...state,
        createCollectionWithAirtablePending: true,
        createCollectionWithAirtableError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_SUCCESS:
      return {
        ...state,
        createCollectionWithAirtablePending: false,
        createCollectionWithAirtableError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_FAILURE:
      return {
        ...state,
        createCollectionWithAirtablePending: false,
        createCollectionWithAirtableError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_AIRTABLE_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithAirtableError: null,
      };

    default:
      return state;
  }
}
